import classnames from 'classnames'
import { RateCurrency } from 'shared/price-utilities'

import bookingStyles from '../styles.module.scss'

const TotalPrice = ({ rate, discountedTotalPrice, additionalServices }) => (
    <div>
        <div className="d-flex justify-content-between mb-1">
            <span className="font-weight-bold">{rate?.rateName}</span>
            <div>
                {discountedTotalPrice != null && (
                    <span className={classnames('font-weight-bold', bookingStyles.defaultAmount)}>
                        <RateCurrency rate={rate} value={rate?.amount} />
                    </span>
                )}
                <span className="font-weight-bold">
                    <RateCurrency
                        rate={rate}
                        value={discountedTotalPrice != null ? discountedTotalPrice : rate?.amount}
                    />
                </span>
            </div>
        </div>
        {additionalServices &&
            additionalServices.map((service, index) => (
                <div key={index} className="d-flex justify-content-between">
                    <span className="font-weight-bold">{service.feeName}</span>
                    <span className="font-weight-bold">
                        <RateCurrency rate={rate} value={service.value} currency={rate?.currencySymbol} />
                    </span>
                </div>
            ))}
    </div>
)

export default TotalPrice
